import { memo } from 'react';
import { Field } from './Field';
import HouseIcon from '~/images/house-icon.svg';

interface ISelectOfficeProps {
  value: string;
  isDisabled?: boolean;
}

const Component = ({ isDisabled = false, value }: ISelectOfficeProps) => (
  <Field
    ComponentProps={{
      Button: { 'data-cy': 'select-office-trigger', 'data-testid': 'select-office-trigger' },
      Container: { 'data-cy': 'select-office', 'data-testid': 'select-office' },
    }}
    IconSrc={HouseIcon}
    isDisabled={isDisabled}
    title="Office:"
    value={value}
  />
);

export const SelectOffice = memo(Component);
